/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Vue from "vue";
import Cons from 'Constant';
import Utils from "Utils";
import Public from 'Public';
import Tab from "vux/src/components/tab/tab.vue";
import TabItem from "vux/src/components/tab/tab-item.vue";
import Swiper from "vux/src/components/swiper/swiper.vue";
import SwiperItem from "vux/src/components/swiper/swiper-item.vue";
import Clocker from "vux/src/components/clocker/index.vue";
import CopyRight from 'CopyRight';
import NoData from 'NoData';
import BScroll from '@/components/Bscroll';
import CompRegItem from './CompRegItem';
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import { ACTION_APPTREG_GETMYREGLIST, GETTER_APPTREG_REGNOWLIST, GETTER_APPTREG_REGHISLIST } from '@/store/mutation_types';
export default {
  data: function data() {
    return {
      curPage: 0,

      /*当前分页位置 */
      isShowDetail: false,
      regInfo: {
        patientVisit: {}
      },
      hasLoad: false
    };
  },
  watch: {
    curPage: function curPage() {}
  },
  components: {
    Tab: Tab,
    TabItem: TabItem,
    Swiper: Swiper,
    SwiperItem: SwiperItem,
    Clocker: Clocker,
    CopyRight: CopyRight,
    CompRegItem: CompRegItem,
    NoData: NoData,
    BScroll: BScroll
  },
  mounted: function mounted() {},
  computed: _objectSpread(_objectSpread({}, mapGetters({
    regNowList: GETTER_APPTREG_REGNOWLIST,
    regHisList: GETTER_APPTREG_REGHISLIST
  })), {}, {
    tapListComp: function tapListComp() {
      var list = [];
      console.log('this.regNowList.length=' + this.regNowList.length);
      list.push('当前预约 ( ' + this.regNowList.length + ' )');
      list.push('历史预约 ( ' + this.regHisList.length + ' )');
      return list;
    },
    itemComp: function itemComp() {
      var itemArr = this.regInfo && this.regInfo.healthProductItemName && '' != this.regInfo.healthProductItemName ? this.regInfo.healthProductItemName.split('，') : [];
      return itemArr;
    },
    emptyNow: function emptyNow() {
      return this.emptyFlag(this.regNowList);
    },
    emptyHis: function emptyHis() {
      return this.emptyFlag(this.regHisList);
    }
  }),
  created: function created() {
    this.turnPage = Utils.getUrlByParam('turnPage');
    this.getMyRegListAjax();
  },
  methods: _objectSpread(_objectSpread({}, mapActions([ACTION_APPTREG_GETMYREGLIST])), {}, {
    /**
     * 获取我的预约列表 getMyRegListAjax
     */
    getMyRegListAjax: function getMyRegListAjax() {
      var _this = this;

      var that = this;
      that.ACTION_APPTREG_GETMYREGLIST().then(function (data) {
        console.log(_this.regNowList);
        console.log(_this.regHisList);
        _this.hasLoad = true;
        console.log(_this.emptyNow); // that.$nextTick(function() {
        //     that.myScrollHis.refresh()
        //     that.myScrollNow.refresh()
        // });
      });
    },

    /**
     * 数据刷新
     */
    listRefresh: function listRefresh() {
      this.getMyRegListAjax();
    },
    emptyFlag: function emptyFlag(data) {
      if (data.length == 0 || !data) {
        return true;
      } else {
        return false;
      }
    }
  })
};